import selectionFilterModalTemplate from './selectionFilterModel.html';
import selectionFilterTemplate from './selectionFilter.html';

const selectionFilterModel = {
    bindings: {
        selectionsPromise: '=',
        isFilterApplied: '=',
        filterTitle: '@',
        type: '@'
    },
    template: selectionFilterTemplate,
    controller: function ($scope, $rootScope, $ionicModal) {
        this.modal = $ionicModal.fromTemplate(selectionFilterModalTemplate, { scope: $scope });
        this.$rootScope = $rootScope;
        this.$onInit = () => {
            // flag to set the display of the dynamic buttons that are created when user
            // selects a fitler value
            this.showButtons = false;

            this.filter = {};
            this.filter.investmentTypes = [];
            this.filter.regions = [];
            this.filter.countries = [];

            this.selectionsPromise.promise.then((res) => {
                this.selections = res;
                if (this.selections && this.selections.length > 0) {
                    this.deferFilterInfoFromSelections(this.selections);
                }
            });
        };

        this.deferFilterInfoFromSelections = (selections) => {
            var uniqueInvestmentTypeIds = [];
            var uniqueRegionIds = [];
            let uniqueCountryIds = new Set();
            this.selections.forEach((selection) => {
                var investmentTypeArray = [];
                if (selection.investmentType && selection.investmentType.indexOf(';') > 0) {
                    investmentTypeArray = selection.investmentType.split(';');
                } else {
                    investmentTypeArray.push(selection.investmentType);
                }

                for (let i = 0; i < investmentTypeArray.length; i++) {
                    var investmentType = investmentTypeArray[i];
                    if (uniqueInvestmentTypeIds.indexOf(investmentType) < 0) {
                        /* This if-check is done because in the display Public Pension Fund and Corporate Pension Fund are replaced through Pension Fund.
                        Sovereign Wealth Fund and Development Bank are replaced through Sovereign Wealth/Development Bank.
                        In the filter only Corporate Pension Fund and Sovereign Wealth Fund are added and are replaced in the display with the values
                        Pension Fund, Sovereign Wealth/Development Bank respectively. */
                        if (investmentTypeArray[i] !== 'Public Pension Fund' && investmentType !== 'Development Bank') {
                            uniqueInvestmentTypeIds.push(investmentType);
                            let investmentTypeObject = {};
                            investmentTypeObject.name = investmentType;
                            this.filter.investmentTypes.push(investmentTypeObject);
                        }
                    }
                }

                if (selection.region !== null && uniqueRegionIds.indexOf(selection.region) < 0) {
                    uniqueRegionIds.push(selection.region);
                    let regionObject = {};
                    regionObject.name = selection.region;
                    this.filter.regions.push(regionObject);
                }

                if (selection.country !== null) {
                    let countries = selection.country.split(/;/g);
                    countries.forEach((country) => {
                        if (!uniqueCountryIds.has(country)) {
                            uniqueCountryIds.add(country);
                            this.filter.countries.push({ 'name': country });
                        }
                    });
                }
            });
        };

        // show and hide countries if europe is checked or not
        this.detectChange = (region) => {
            if (region.name == 'Europe' && region.checked) {
                this.showCountries = true;
            } else {
                this.showCountries = false;
                for (let i = 0; i < this.filter.countries.length; i++) {
                    this.filter.countries[i].checked = false;
                }
            }
        };

        // Check and uncheck investment types
        this.detectInvestmentCategory = (isInvestmentTypePAI) => {
            if (isInvestmentTypePAI) {
                for (let i = 0; i < this.filter.investmentTypes.length; i++) {
                    if (this.filter.investmentTypes[i].name === 'Insurance Company' || this.filter.investmentTypes[i].name === 'Corporate Pension Fund' || this.filter.investmentTypes[i].name === 'Public Pension Fund') {
                        this.filter.investmentTypes[i].checked = true;
                    } else {
                        this.filter.investmentTypes[i].checked = false;
                    }
                }
            } else {
                for (let i = 0; i < this.filter.investmentTypes.length; i++) {
                    if (this.filter.investmentTypes[i].name === 'Insurance Company' || this.filter.investmentTypes[i].name === 'Corporate Pension Fund' || this.filter.investmentTypes[i].name === 'Public Pension Fund') {
                        this.filter.investmentTypes[i].checked = false;
                    } else {
                        this.filter.investmentTypes[i].checked = true;
                    }
                }

                for (let i = 0; i < this.filter.regions.length; i++) {
                    this.filter.regions[i].checked = false;
                }

                for (let i = 0; i < this.filter.countries.length; i++) {
                    this.filter.countries[i].checked = false;
                }
            }
        };

        this.onFilter = () => {
            let self = this;

            // create an encapsulated filter object from the values selected by the user
            let filter = this.createFilterObject();
            let isInvestmentTypeFilterApplied = filter.investmentTypes.length > 0;
            let isRegionFilterApplied = filter.regions.length > 0;
            let isCountryFilterApplied = filter.countries.length > 0;
            let areFiltersApplied = isRegionFilterApplied || isInvestmentTypeFilterApplied || isCountryFilterApplied;

            if (areFiltersApplied) {
                this.isFilterApplied = true;
            }

            this.selections.forEach((selection) => {
                let isSelectionOfInvestmentType = filter.investmentTypes.find((investmentType) => {
                    // check if the string contains the filter string
                    return selection.investmentType && selection.investmentType.indexOf(investmentType.name) >= 0;
                });
                let isSelectionOfRegion = filter.regions.find((region) => {
                    if (isCountryFilterApplied) {
                        return selection.region && region.name === selection.region && selection.country !== null;
                    } else {
                        return selection.region && region.name === selection.region && selection.country === null;
                    }

                });
                let isSelectionOfCountry = filter.countries.find((country) => {
                    return selection.country && selection.country.includes(country.name);
                });
                var show = ((!isRegionFilterApplied && isSelectionOfInvestmentType && isSelectionOfCountry) || (!isInvestmentTypeFilterApplied && isSelectionOfRegion && isSelectionOfCountry) || (!isCountryFilterApplied && isSelectionOfRegion && isSelectionOfInvestmentType)) ||
                    ((!isRegionFilterApplied && !isCountryFilterApplied && isSelectionOfInvestmentType) || (!isInvestmentTypeFilterApplied && !isRegionFilterApplied && isSelectionOfCountry) || (!isCountryFilterApplied && !isInvestmentTypeFilterApplied && isSelectionOfRegion)) ||
                    (isSelectionOfInvestmentType && isSelectionOfRegion && isSelectionOfCountry) ||
                    !areFiltersApplied;
                selection.hide = !show;
            });
        };

        this.createFilterObject = () => {
            let self = this;

            // temp object for creating and returning the user selected filter values
            let tempFilter = {};
            tempFilter.investmentTypes = [];
            tempFilter.regions = [];
            tempFilter.countries = [];

            for (let i = 0; i < self.filter.investmentTypes.length; i++) {
                if (self.filter.investmentTypes[i].checked) {
                    tempFilter.investmentTypes.push(self.filter.investmentTypes[i]);
                }
            }

            for (let i = 0; i < this.filter.regions.length; i++) {
                if (this.filter.regions[i].checked) {
                    tempFilter.regions.push(this.filter.regions[i]);
                }
            }

            for (let i = 0; i < this.filter.countries.length; i++) {
                if (this.filter.countries[i].checked) {
                    tempFilter.countries.push(this.filter.countries[i]);
                }
            }

            return tempFilter;
        };

        /**
         * Hide the buttons when user clicks the remove buttons
         * @param  {string} text      Value displayed on the buttons
         * @param  {string} arrayName Name of the collection in the filter object
         * @return {void}
         */
        this.dropFilter = (selectedFilter, filterType) => {
            let filterOptions = {};

            switch (filterType) {
                case 'investmentTypes':
                    filterOptions = this.filter.investmentTypes;
                    break;
                case 'regions':
                    filterOptions = this.filter.regions;
                    if (selectedFilter.name == 'Europe' && selectedFilter.checked) {
                        this.showCountries = false;
                        for (let i = 0; i < this.filter.countries.length; i++) {
                            this.filter.countries[i].checked = false;
                        }
                    }

                    break;
                case 'countries':
                    filterOptions = this.filter.countries;
                    break;
                default:
                    return;
            }

            var filterToBeDropped = filterOptions[filterOptions.indexOf(selectedFilter)];
            filterToBeDropped.checked = false;

            this.onFilter();

            // The following part is required to remove the buttons section if the user removes all filters.
            let isInvestmentTypeFilterApplied = this.filter.investmentTypes.find((investmentType) => {
                return investmentType.checked;
            });
            let isRegionFilterApplied = this.filter.regions.find((region) => {
                return region.checked;
            });
            let isCountryFilterApplied = this.filter.countries.find((country) => {
                return country.checked;
            });

            if (!isRegionFilterApplied && !isInvestmentTypeFilterApplied && !isCountryFilterApplied) {
                this.showButtons = false;
                this.isFilterApplied = false;
            }
        };

        this.dropAllFilters = () => {
            this.filter.investmentTypes.forEach((investmentType) => {
                investmentType.checked = false;
            });

            this.filter.regions.forEach((region) => {
                region.checked = false;
            });

            this.filter.countries.forEach((country) => {
                country.checked = false;
            });

            this.showButtons = false;
            this.isFilterApplied = false;
        };

        this.openModal = () => {
            this.modal.show();
            this.showButtons = false;
            this.originalFilter = angular.copy(this.filter);
        };

        this.closeModal = () => {
            this.modal.hide();
            this.filter = this.originalFilter;
            this.showButtons = true;
        };

        this.filterData = () => {
            this.onFilter();
            this.modal.hide();
            this.showButtons = true;
        };

        this.toggleTopsellers = () => {
            this.topsellerActive = !this.topsellerActive;

            if (this.topsellerActive) {
                this.showButtons = false;
                this.dropAllFilters();
                this.selections.forEach((selection) => {
                    selection.hide = !selection.topseller;
                });
            }

            this.isFilterApplied = this.topsellerActive;
        };
    }
};

export default selectionFilterModel;



/** WEBPACK FOOTER **
 ** ./src/app/directives/selectionFilterModel/selectionFilterModel.js
 **/